// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
import { useEffect, useRef } from 'react';

interface UseTimeoutOptions {
    // poll interval duration
    delay: number;
    shouldCall: boolean;
}

export function useTimeout(
    callback: any,
    { delay, shouldCall }: UseTimeoutOptions,
) {
    const savedCallback = useRef(callback);

    // remember the callback to the interval
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        if (delay === null) {
            return undefined;
        }
        if (shouldCall && delay) {
            const id = setTimeout(() => {
                savedCallback.current();
            }, delay);
            return () => {
                clearTimeout(id);
            };
        }
        return undefined;
    }, [delay]);
}
